import type { Order } from '@scayle/storefront-nuxt'
import type { CheckoutType } from './types'
import useLocalStorage from '#layers/base/composables/useLocalStorage'

type StorageKey = Order['basketKey']

export type ICheckoutTracking = {
  checkout_type: CheckoutType
  newsletter_signup?: boolean
}

interface ICheckoutTrackingStorageFormat {
  // key is basketKey
  [key: StorageKey]: ICheckoutTracking
}

const defaultCheckoutTrackingStore = {}

const { stored, set } = useLocalStorage<ICheckoutTrackingStorageFormat>(
  'checkoutTracking',
  defaultCheckoutTrackingStore,
)

const useCheckoutTrackingLocalStorage = () => {
  const getStoredCheckoutTrackingItem = (
    basketKey: StorageKey,
  ): ICheckoutTracking | undefined => stored.value?.[basketKey]

  const storeCheckoutTracking = (value: ICheckoutTrackingStorageFormat) => {
    set({
      ...stored.value,
      ...value,
    })
  }

  const deleteCheckoutTrackingItems = (basketKeys: StorageKey[]) => {
    const storedCopy = { ...stored.value }

    for (let i = 0; i < basketKeys.length; i++) {
      const basketKey = basketKeys[i]
      if (basketKey === undefined) {
        continue
      }
      // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
      delete storedCopy[basketKey]
    }

    set(storedCopy)
  }

  return {
    getStoredCheckoutTrackingItem,
    storeCheckoutTracking,
    deleteCheckoutTrackingItems,
  }
}

export default useCheckoutTrackingLocalStorage
